import { FC } from 'react';
import { URLS } from '../../constants/currency';
import type { CountryInfoWithCurrency } from '../../types/country-info';

type CurrencyChangeButtonProps = {
  countryInfo: CountryInfoWithCurrency;
  onClick: () => void;
};

export const CurrencyChangeButton: FC<CurrencyChangeButtonProps> = ({
  countryInfo,
  onClick,
}) => (
  <button
    type="button"
    onClick={onClick}
    className="font-border flex h-[42px] w-fit items-center rounded-md border-2 border-[#ECEAED33] px-4 py-1 transition-all duration-200 hover:bg-[#ECEAED33] hover:brightness-125"
  >
    <div className="flex items-center gap-2 text-[17.5px] font-bold uppercase">
      <span className="mt-0.5 flex items-center justify-center text-2xl">
        {countryInfo.flagEmoji}
      </span>
      {countryInfo.currency}
      -
      {countryInfo.currencySymbol}
      <img
        src={URLS.arrowDown}
        alt="arrow down"
        className="size-5"
      />
    </div>
  </button>
);
